export const UserVisibilitySettingsLabelMap: Record<string, string> = {
  Admin: "Admin",
  Self: "Me",
  "Team Member": "Everyone on my team(s)",
  "Team Leader": "My team leader(s)",
  Manager: "My manager",
  "Senior Manager": "My senior manager(s)",
  "Department Leader": "My department leader(s)",
  "Organization Member": "Everyone in my organization",
};

export const NotificationReminderOptions = [
  { label: "5 minutes before", value: 5 },
  { label: "10 minutes before", value: 10 },
  { label: "15 minutes before", value: 15 },
  { label: "30 minutes before", value: 30 },
  { label: "1 hour before", value: 60 },
];
